const ICON_BY_TYPE = { article: 'article', audio: 'audio', image: 'image', link: 'link', video: 'video', '3d': 'cube' };

/**
 * The type only picks the icon, and it reaches the reader as a plain string
 * the API validates as nullable — so an unknown one falls back rather than
 * rendering a missing glyph.
 *
 * @param {string|null|undefined} type - An add-on's `type`
 * @returns {string} The name of the icon to draw
 */
export function addOnIcon(type) {
    return Object.prototype.hasOwnProperty.call(ICON_BY_TYPE, type) ? ICON_BY_TYPE[type] : 'article';
}
